import { z } from 'zod'

export const cpcInputSchema = z.object({
  symbols: z.string().array(),
})

export const cpcSchema = z.object({
  level: z.enum(['section', 'class', 'subclass', 'group']),
  symbol: z.string(),
  description: z.string(),
})

export const cpcApiResponseSchema = z.object({
  data: z.array(cpcSchema),
})
